$(document).on('submit', '#poptavkovyForm', function(e) { 
    $(this).addClass('loading-form')
    e.preventDefault(); 
    var formName = $(this).find('#nameAndSurname').val()
    var formPhone = $(this).find('#phone').val()
    var formEmail = $(this).find('#email').val()
    var formMEessage = $(this).find('#textarea').val()
    var formdata = new FormData();
    formdata.append("name", formName);
    formdata.append("phone", formPhone);
    formdata.append("email", formEmail);
    formdata.append("message", formMEessage);
    var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };
    fetch("https://tools.shopcode.cz/e-mail_sender/bitcoin/www/", requestOptions)
    .then(response => response.json())
    .then(function(result){
       console.log(result)
       
        if(result.status === 'ok'){
            showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
            $('#poptavkovyForm').find('input:not([type="submit"])').val()
            $('#poptavkovyForm').find('textarea').val()
        }
        else if (result.length > 0 && result[0].message) {
            var errorMessages = result.map(function(error) {
                return error.message;
            }).join('<br>');
            showMessage('Formulář obsahuje chyby:<br>' + errorMessages, 'error', '', false, true);
            $('#poptavkovyForm').removeClass('loading-form');
        }
    })
    .catch(function(){
        showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
        $('#poptavkovyForm').removeClass('loading-form')
    })
})


$(document).on('submit', '.customRezervationForm', function(e) { 
    $(this).addClass('loading-form')
    e.preventDefault(); 
    var formPhone = $(this).find('#text').val()
    var formEmail = $(this).find('#email').val()
    var formdata = new FormData();
    formdata.append("text", formPhone);
    formdata.append("email", formEmail);
    var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };
    fetch("https://tools.shopcode.cz/e-mail_sender/bitcoin-kody/www/", requestOptions)
    .then(response => response.json())
    .then(function(result){
       console.log(result)
       
        if(result.status === 'ok'){
            showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
            $('#poptavkovyForm').find('input:not([type="submit"])').val()
            $('#poptavkovyForm').find('textarea').val()
        }
        else if (result.length > 0 && result[0].message) {
            var errorMessages = result.map(function(error) {
                return error.message;
            }).join('<br>');
            showMessage('Formulář obsahuje chyby:<br>' + errorMessages, 'error', '', false, true);
            $('#poptavkovyForm').removeClass('loading-form');
        }
    })
    .catch(function(){
        showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
        $('#poptavkovyForm').removeClass('loading-form')
    })
})